import { render, staticRenderFns } from "./_remoteEdu.vue?vue&type=template&id=16677c35&scoped=true"
import script from "./_remoteEdu.vue?vue&type=script&lang=js"
export * from "./_remoteEdu.vue?vue&type=script&lang=js"
import style0 from "./_remoteEdu.vue?vue&type=style&index=0&id=16677c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16677c35",
  null
  
)

export default component.exports